import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { AxiosHeaders, AxiosRequestConfig } from 'axios';

import { DefaultListEventTypesQueryPayload } from './includes/defaults';
import { ListEventTypesSchema } from './includes/schema';
import { ListEventTypesData, ListEventTypesQueryPayload } from './includes/types';

interface CustomRequestHeaders extends AxiosHeaders {
  'x-api-endpoint': string;
}

/**
 * Query: ListEventTypes
 *
 * Retrieves a list of event types from the remote API via an authenticated GET request.
 * Validates the response data using a Zod schema.
 * Logs errors and rethrows them for upstream handling.
 */
export const ListEventTypes = async (
  payload: ListEventTypesQueryPayload = DefaultListEventTypesQueryPayload
): Promise<ListEventTypesData> => {
  try {
    const [theApiKey, theQueryKey] = payload;

    const requestArgs: AxiosRequestConfig = {
      baseURL: config('API_URL'),
      headers: { 'x-api-endpoint': '/code-lists/categories/EventType' } as CustomRequestHeaders,
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);
    return ListEventTypesSchema.parse(remoteResponse.data);
  } catch (error) {
    logger.error(
      'src/entities/Event/api/requests/queries/ListEventTypes/ListEventTypes.ts -> ListEventTypes()',
      false,
      error
    );
    throw error;
  }
};
